<template>
  <div class="home">
    <SalesList v-show="listView" @newSales="onClickNewFromList" @editSales="onClickEditFromList" @editPayment="onClickPaymentForm" @editDelivery="onClickDeliveryForm" @editRetur="onClickReturForm" :scroll="corY" ref="refreshList"/>
    <SalesForm v-show="formView" :sales="sales" :detailColl="detailColl" @backClicked="onBackChild" @backParentID="backParentID" @onPayment="onClickPaymentFromForm" @onBstk="onClickBstkFromForm" @backClickID="getEditSales" ref="getCustomerOutstanding"/>
    <SalesPayment v-show="paymentView" :sales="sales" :payment="payment" @backClicked="onBackChild" @cancelPayment="cancelPayment" @savePayment="onClickEditFromList" />
    <SalesDelivery v-show="bstkView" :sales="sales" :delivery="delivery" @backClicked="onBackChild" />
    <SalesRetur v-show="returView" :sales="sales" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SalesList from '@/components/sales/SalesList.vue'
import SalesForm from '@/components/sales/SalesForm.vue'
import SalesPayment from '@/components/sales/SalesPayment.vue'
import SalesDelivery from '@/components/sales/SalesDelivery.vue'
import SalesRetur from '@/components/sales/SalesRetur.vue'
// import SalesBstk from '@/components/sales/SalesBstk.vue'
import { salesUrl, getHeader } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Sales',
  components: {
    SalesList,
    SalesForm,
    SalesPayment,
    SalesDelivery,
    SalesRetur
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      paymentView: false,
      bstkView: false,
      returView: false,
      sales: {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          rating_id: null,
          rating: null,
          plafond_type: null,
          plafond_amount: '0'
        },
        branch_no: '100',
        warehouse_no: 'WH0002',
        branch: null,
        subtotal: null,
        tax_id: null,
        taxes: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        supervisor_id: null,
        supervisor: null,
        status: null,
        price_id: null,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: null,
        print_counter: '0',
        bstk_counter: '0',
        return_total: '0',
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        notes: null,
        check_tanda_terima: false,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product_sku: null,
          product: null,
          products: {
            canBarcode: null
          },
          description: null,
          barcode: null,
          qty: null,
          qty_done: null,
          serial_number: null,
          sec_serial_number: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          total_tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          warehouse_no: null,
          order_no: null,
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }],
          cost: '0',
          cost_id: null,
          margin: '0',
          margin_percentage: '0',
          internal_code: null,
          lock: false
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: false,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            total_tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          sale_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null
        }],
        orders: [{
          id: null,
          order_no: null,
          order_date: null,
          order_due_date: null,
          type_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: '0',
          discount: '0',
          margin: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          status: null,
          salesman_id: null,
          surveyor_id: null,
          order_notes: null,
          survey_notes: null,
          project_name: null,
          term_no: null,
          term_notes: null,
          approve_by: null,
          approve_date: null,
          company_no: null,
          term_due_id: null,
          finish: false,
          lock: false,
          details: [{
            id: null,
            order_no: null,
            order_date: null,
            branch_no: null,
            product_no: null,
            description: null,
            qty: '0',
            qty_done: '0',
            serial_number: null,
            uom_id: null,
            cost: null,
            price: '0',
            discount: '0',
            discount_percentage: '0',
            margin: '0',
            tax_id: null,
            tax: '0',
            total_tax: '0',
            subtotal: '0',
            total: '0',
            queue: null,
            cost_id: null,
            product_sku: null,
            sec_serial_number: null,
            company_no: null
          }]
        }],
        projects: [{
          project_no: null,
          sale_no: null,
          project_name: null,
          type_id: null,
          schedule_date: null,
          start_project: null,
          end_project: null,
          customer_no: null,
          customer: {
            id: null,
            customer_no: null,
            name: null,
            group_id: null,
            email: null,
            phone: null,
            address: null,
            city_id: null,
            state_id: null,
            identity_number: null,
            vat: null,
            birthday: null,
            birthplace: null,
            twitter: null,
            facebook: null,
            instagram: null,
            card_id: null,
            level_id: null,
            rating_id: null,
            rating: null,
            plafond_type: null,
            plafond_amount: '0'
          },
          notes: null,
          pic: null,
          user_pic: null,
          branch_no: null,
          status: null,
          estimated_date: null
        }],
        opexs: [{
          id: null,
          sale_no: null,
          amount: '0',
          opex_date: null,
          type: null,
          bank_id: null,
          user_id: null,
          notes: null,
          vendor_no: null
        }],
        deliveries: [{
          id: null,
          deliver_no: null,
          sale_no: null,
          deliver_date: null,
          notes: null,
          employee_no: null,
          type_id: null,
          branch_no: null,
          company_no: null,
          delivery_term: null,
          details: [{
            id: null,
            deliver_no: null
          }]
        }],
        workshops: [{
          id: null,
          type_id: null,
          type: null,
          workshop_no: null,
          date_in: null,
          date_out: null,
          customer_no: null,
          customer: {
            id: null,
            name: null,
            phone: null,
            address: null,
            rating_id: null,
            rating: null,
            plafond_type: null,
            plafond_amount: '0'
          },
          customer_note: null,
          work_order: null,
          notes: null,
          get_backup: null,
          change_part: null,
          engineer_id: null,
          subtotal: null,
          discount: null,
          tax_id: null,
          tax: null,
          total: null,
          specification: null,
          status: null,
          branch_no: null,
          work_start: null,
          work_finish: null,
          receiver_id: null,
          server_id: null,
          hours: null,
          next_service: null,
          schedule_date: null,
          due_date: null,
          sale_no: null
        }],
        attachments: [{
          id: null,
          sale_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        total_payment: null
      },
      payment: [{
        id: null,
        payment_no: null,
        sale_no: null,
        payment_date: null,
        price: '0',
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: null,
        prepayment_date: null,
        group_no: null,
        account_code: null
      }],
      delivery: {
        id: null,
        deliver_no: null,
        sale_no: null,
        deliver_date: null,
        notes: null,
        employee_no: null,
        type_id: null,
        branch_no: null,
        company_no: null,
        delivery_term: null,
        details: [{
          id: null,
          deliver_no: null,
          serial_number: null,
          sec_serial_number: null,
          qty: '0',
          product_no: null,
          warehouse_no: null,
          uom_id: null,
          queue: null,
          branch_no: null,
          company_no: null
        }]
      },
      detailColl: [{
        id: null,
        sale_no: null,
        sale_date: null,
        branch_no: null,
        branch: null,
        product_no: null,
        product_sku: null,
        product: null,
        products: {
          canBarcode: null
        },
        description: null,
        barcode: null,
        qty: null,
        qty_done: null,
        serial_number: null,
        sec_serial_number: null,
        uom_id: null,
        price: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        discount_percentage: '0',
        subtotal: '0',
        total: '0',
        queue: null,
        warehouse_no: null,
        order_no: null,
        uomType: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: '0',
          active: false,
          cost: '0',
          price: '0'
        }],
        cost: '0',
        cost_id: null,
        margin: '0',
        margin_percentage: '0',
        internal_code: null,
        lock: false
      }]
    }
  },
  methods: {
    onClickReturForm (value) {
      this.listView = false
      this.formView = false
      this.paymentView = false
      this.bstkView = false
      this.returView = true
      this.sales = value
    },
    onClickDeliveryForm (value) {
      this.listView = false
      this.formView = false
      this.paymentView = false
      this.bstkView = true
      this.returView = false
      this.sales = value
      if (this.sales.deliveries.length === 0) {
        var array = this.sales.details
        var detailLoop = []
        var obj = {}
        for (let i = 0; i < array.length; i++) {
          if (array[i].can_barcode === true) {
            for (let a = 0; a < array[i].qty; a++) {
              obj = {
                deliver_no: null,
                serial_number: '',
                sec_serial_number: '',
                qty: 1,
                product_no: array[i].product_no,
                product: array[i].description,
                warehouse_no: array[i].warehouse_no,
                uom_id: array[i].uom_id,
                queue: null,
                branch_no: array[i].branch_no,
                company_no: array[i].company_no,
                can_barcode: array[i].can_barcode
              }
              detailLoop.push(obj)
            }
          } else {
            obj = {
              deliver_no: null,
              serial_number: null,
              sec_serial_number: null,
              qty: array[i].qty,
              product_no: array[i].product_no,
              product: array[i].description,
              warehouse_no: array[i].warehouse_no,
              uom_id: array[i].uom_id,
              queue: null,
              branch_no: array[i].branch_no,
              company_no: array[i].company_no,
              can_barcode: false
            }
            detailLoop.push(obj)
          }
        }
        this.delivery = {
          id: null,
          deliver_no: null,
          sale_no: this.sales.sale_no,
          deliver_date: new Date().toISOString(),
          notes: null,
          employee_no: null,
          type_id: 'final',
          branch_no: this.sales.branch_no,
          company_no: this.sales.company_no,
          delivery_term: null,
          details: detailLoop
        }
      } else {
        var dlv = this.sales.deliveries.find(d => d.type_id === 'final')
        this.delivery = {
          id: dlv.id,
          deliver_no: dlv.deliver_no,
          sale_no: dlv.sale_no,
          deliver_date: dlv.deliver_date,
          notes: dlv.notes,
          employee_no: dlv.employee_no,
          type_id: dlv.type_id,
          branch_no: dlv.branch_no,
          company_no: dlv.company_no,
          delivery_term: dlv.delivery_term,
          details: dlv.details
        }
      }
      this.$store.dispatch('getDeliveryTypeList')
    },
    onClickPaymentForm: function (value) {
      this.listView = false
      this.formView = false
      this.paymentView = true
      this.bstkView = false
      this.returView = false
      this.sales = value
      this.payment = this.sales.payments
    },
    backParentID: function (id) {
      axios.get(salesUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.listView = false
          this.formView = true
          this.paymentView = false
          this.bstkView = false
          this.returView = false
          this.sales = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickBstkFromForm: function (value) {
      this.listView = false
      this.formView = false
      this.paymentView = false
      this.bstkView = true
      this.returView = false
      this.sales = value
    },
    async onClickEditFromList (value) {
      console.log(value)
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.paymentView = false
      this.bstkView = false
      this.returView = false
      this.sales = value
      this.detailColl = value.details
      var obj = {
        customer_no: this.sales.customer_no
      }
      await this.$store.dispatch('getCustomerOutstadingTotal', obj)
    },
    getEditSales: function (value) {
      axios.get(salesUrl + '/' + value, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.listView = false
          this.formView = true
          this.paymentView = false
          this.bstkView = false
          this.returView = false
          this.sales = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.paymentView = false
      this.bstkView = false
      this.returView = false
      // get company tax
      var company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var taxid = company ? company.tax_id : null
      var warehouse = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      this.sales = {
        id: null,
        sale_no: null,
        sale_date: date,
        sale_due_date: null,
        type_id: '1',
        customer_no: null,
        branch_no: this.authUser.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        subtotal: '0',
        tax_id: taxid,
        taxes: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        supervisor_id: null,
        supervisor: null,
        status: null,
        lock: false,
        price_id: null,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: this.authUser.company_no,
        print_counter: '0',
        bstk_counter: '0',
        return_total: '0',
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        notes: null,
        check_tanda_terima: false,
        details: [],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: false,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: '0',
            cost: '0',
            cost_id: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          sale_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null
        }],
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          rating_id: null,
          rating: null,
          plafond_type: null,
          plafond_amount: '0'
        },
        orders: [],
        opexs: [{
          id: null,
          sale_no: null,
          amount: '0',
          opex_date: null,
          type: null,
          bank_id: null,
          user_id: null,
          notes: null,
          vendor_no: null
        }],
        deliveries: [{
          id: null,
          deliver_no: null,
          sale_no: null,
          deliver_date: null,
          notes: null,
          employee_no: null,
          type_id: null,
          branch_no: null,
          company_no: null,
          delivery_term: null,
          details: [{
            id: null,
            deliver_no: null
          }]
        }],
        workshops: [],
        attachments: [],
        total_payment: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.paymentView = false
      this.bstkView = false
      this.returView = false
      this.sales = {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          rating_id: null,
          rating: null,
          plafond_type: null,
          plafond_amount: '0'
        },
        branch_no: null,
        warehouse_no: null,
        branch: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        supervisor_id: null,
        supervisor: null,
        status: null,
        price_id: 1,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: this.authUser.company_no,
        print_counter: '0',
        bstk_counter: '0',
        return_total: '0',
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        notes: null,
        check_tanda_terima: false,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product_sku: null,
          product: null,
          products: {
            canBarcode: null
          },
          description: null,
          barcode: null,
          qty: null,
          qty_done: null,
          serial_number: null,
          sec_serial_number: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          total_tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          warehouse_no: null,
          order_no: null,
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }],
          cost: '0',
          cost_id: null,
          margin: '0',
          margin_percentage: '0',
          internal_code: null,
          lock: false
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: false,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          sale_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null
        }],
        orders: [{
          id: null,
          order_no: null,
          order_date: null,
          order_due_date: null,
          type_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: '0',
          discount: '0',
          margin: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          status: null,
          salesman_id: null,
          surveyor_id: null,
          order_notes: null,
          survey_notes: null,
          project_name: null,
          term_no: null,
          term_notes: null,
          approve_by: null,
          approve_date: null,
          company_no: null,
          term_due_id: null,
          finish: false,
          lock: false,
          details: [{
            id: null,
            order_no: null,
            order_date: null,
            branch_no: null,
            product_no: null,
            description: null,
            qty: '0',
            qty_done: '0',
            serial_number: null,
            uom_id: null,
            cost: null,
            price: '0',
            discount: '0',
            discount_percentage: '0',
            margin: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            queue: null,
            cost_id: null,
            product_sku: null,
            sec_serial_number: null,
            company_no: null
          }]
        }],
        opexs: [{
          id: null,
          sale_no: null,
          amount: '0',
          opex_date: null,
          type: null,
          bank_id: null,
          user_id: null,
          notes: null,
          vendor_no: null
        }],
        deliveries: [{
          id: null,
          deliver_no: null,
          sale_no: null,
          deliver_date: null,
          notes: null,
          employee_no: null,
          type_id: null,
          branch_no: null,
          company_no: null,
          delivery_term: null,
          details: [{
            id: null,
            deliver_no: null
          }]
        }],
        workshops: [{
          id: null,
          type_id: null,
          type: null,
          workshop_no: null,
          date_in: null,
          date_out: null,
          customer_no: null,
          customer: {
            id: null,
            name: null,
            phone: null,
            address: null,
            rating_id: null,
            rating: null,
            plafond_type: null,
            plafond_amount: '0'
          },
          customer_note: null,
          work_order: null,
          notes: null,
          get_backup: null,
          change_part: null,
          engineer_id: null,
          subtotal: null,
          discount: null,
          tax_id: null,
          tax: null,
          total: null,
          specification: null,
          status: null,
          branch_no: null,
          work_start: null,
          work_finish: null,
          receiver_id: null,
          server_id: null,
          hours: null,
          next_service: null,
          schedule_date: null,
          due_date: null,
          sale_no: null
        }],
        attachments: [{
          id: null,
          sale_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        total_payment: null
      }
      // this.$refs.refreshList.refreshSales()
      // this.$router.replace({ path: 'sales', query: null })
    },
    onClickPaymentFromForm: function (value) {
      this.sales = value
      this.paymentView = true
      this.listView = false
      this.bstkView = false
      this.returView = false
      this.formView = false
    },
    cancelPayment: function (id) {
      this.getEditSales(id)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      taxList: state => state.taxes.taxList,
      warehouseList: state => state.warehouses.warehouseList
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getCustomerGroupList')
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
    this.$store.dispatch('getAreaList')
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getSalesTypeList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getSettingList')
    this.$store.dispatch('getChartOfAccountList')
    this.$store.dispatch('getCustomerListLite')
    this.$store.dispatch('getCustomerRatingList')
    // var payload = {
    //   date: new Date().toISOString()
    // }
    // this.$store.dispatch('getProductWithTotal', payload)
    // customer
    // get query param from url
    // var form = this.$route.query.form
    var salesParam = this.$route.query.sales
    if (typeof salesParam !== 'undefined') {
      this.getEditSales(salesParam)
    }
  }
}
</script>
